const NON_ASCII_TO_ASCII_AMOUNT_CHAR_MAP = {
  '０': '0',
  '１': '1',
  '２': '2',
  '３': '3',
  '４': '4',
  '５': '5',
  '６': '6',
  '７': '7',
  '８': '8',
  '９': '9',
  '．': '.',
  '。': '.',
  '｡': '.',
  '，': ',',
  '、': ',',
  '､': ',',
}

/*
 * Convert any non-ASCII input in amount input string to the
 * ASCII counterpart (e.g. for Japananese fullwidth characters)
 *
 * @param {string} input
 * @returns {string} input with any non-ASCII digits/decimals
 *                   converted to their ASCII counterparts
 */
export function normalizeAmountInput(input) {
  if (typeof input !== 'string') {
    return input
  }

  return input.replace(
    new RegExp(
      `[${Object.keys(NON_ASCII_TO_ASCII_AMOUNT_CHAR_MAP).join('')}]`,
      'g'
    ),
    char => NON_ASCII_TO_ASCII_AMOUNT_CHAR_MAP[char]
  )
}
